import { render, staticRenderFns } from "./BooksList.vue?vue&type=template&id=3c739c34"
import script from "./BooksList.vue?vue&type=script&lang=js"
export * from "./BooksList.vue?vue&type=script&lang=js"
import style0 from "./BooksList.vue?vue&type=style&index=0&id=3c739c34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports